import React from "react";
import { message } from "antd";

import { DeleteIcon } from "src/components";
import { compose } from "src/helpers";
import { withDeleteConcept } from "src/modules/concept/operations";
import { captureException } from "@sentry/react";

const DeleteView = (props) => {
    const { deleteConcept, id } = props;

    const handleDelete = async () => {
        try {
            await deleteConcept(id);
            message.success("Deleted!");
        } catch (err) {
            captureException(err)
            message.error("Failed!");
        }
    };

    return <DeleteIcon {...props} onConfirm={handleDelete} />;
};

export default compose(withDeleteConcept)(DeleteView);
